import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const F = ({ id, label, value, onChange, placeholder, type = 'text' }) => (
  <div>
    <Label htmlFor={id}>{label}</Label>
    <Input id={id} data-testid={id} value={value ?? ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} type={type} />
  </div>
);

const PrivateJetForm = ({ details, onChange }) => {
  const set = (k, v) => onChange({ ...details, [k]: v });
  return (
    <div className="space-y-4" data-testid="private-jet-form">
      <div className="grid grid-cols-3 gap-3">
        <F id="ca-pj-manufacturer" label="Manufacturer" value={details.manufacturer} onChange={(v) => set('manufacturer', v)} placeholder="e.g. Gulfstream" />
        <F id="ca-pj-model" label="Model" value={details.model} onChange={(v) => set('model', v)} placeholder="e.g. G650" />
        <F id="ca-pj-year" label="Year" value={details.year} onChange={(v) => set('year', v)} placeholder="2021" type="number" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <F id="ca-pj-tail" label="Tail number" value={details.tail_number} onChange={(v) => set('tail_number', v)} placeholder="e.g. N123AB" />
        <F id="ca-pj-country" label="Country of registration" value={details.registration_country} onChange={(v) => set('registration_country', v)} placeholder="e.g. United States" />
      </div>
      <div>
        <Label htmlFor="ca-pj-ownership">Ownership type</Label>
        <Select value={details.ownership_type || ''} onValueChange={(v) => set('ownership_type', v)}>
          <SelectTrigger id="ca-pj-ownership" data-testid="ca-pj-ownership"><SelectValue placeholder="Pick one" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="owned">Owned outright</SelectItem>
            <SelectItem value="financed">Financed</SelectItem>
            <SelectItem value="fractional">Fractional</SelectItem>
            <SelectItem value="leased">Leased</SelectItem>
            <SelectItem value="jet_card">Jet card programme</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {details.ownership_type === 'fractional' && (
        <div className="grid grid-cols-2 gap-3">
          <F id="ca-pj-fractional-provider" label="Fractional provider" value={details.fractional_provider} onChange={(v) => set('fractional_provider', v)} placeholder="e.g. NetJets" />
          <F id="ca-pj-fractional-share" label="Share owned (%)" value={details.fractional_share} onChange={(v) => set('fractional_share', v ? Number(v) : null)} placeholder="e.g. 12.5" type="number" />
        </div>
      )}
      {details.ownership_type === 'financed' && (
        <div className="grid grid-cols-2 gap-3">
          <F id="ca-pj-lender" label="Lender" value={details.lender_name} onChange={(v) => set('lender_name', v)} placeholder="e.g. JPMorgan Aviation Finance" />
          <F id="ca-pj-balance" label="Outstanding balance" value={details.loan_balance} onChange={(v) => set('loan_balance', v ? Number(v) : null)} placeholder="0" type="number" />
        </div>
      )}
      <div className="grid grid-cols-2 gap-3">
        <F id="ca-pj-hangar" label="Hangar / based at" value={details.hangar_location} onChange={(v) => set('hangar_location', v)} placeholder="e.g. Farnborough, UK" />
        <F id="ca-pj-management" label="Management company" value={details.management_company} onChange={(v) => set('management_company', v)} placeholder="e.g. Jet Aviation" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <F id="ca-pj-insurance" label="Insurance policy" value={details.insurance_reference} onChange={(v) => set('insurance_reference', v)} placeholder="Insurer / policy #" />
        <F id="ca-pj-maintenance" label="Maintenance provider" value={details.maintenance_provider} onChange={(v) => set('maintenance_provider', v)} placeholder="e.g. Gulfstream Service Center" />
      </div>
    </div>
  );
};

export default PrivateJetForm;
